import {Box} from '@mui/material';

import {JobPostingBody} from './JobPostingBody';
import {JobPostingHeader} from './JobPostingHeader';
import {JobPosting} from '../../features/company/recruiting/job-postings/types/JobPostingsTypes';

interface Props {
  jobPosting: JobPosting;
}
export const JobPostingDetailsApplicant = ({jobPosting}: Props) => {
  return (
    <Box
      sx={{
        padding: '32px',
      }}
    >
      <JobPostingHeader jobPosting={jobPosting} />
      <JobPostingBody jobPosting={jobPosting} />
    </Box>
  );
};
